const shareCopy = document.querySelector('.share-copy a');
if (shareCopy) {
    shareCopy.addEventListener('click', function(e) {
        e.preventDefault();
        if (!navigator.clipboard) {
            return;
        }
        navigator.clipboard.writeText(shareCopy.href).then(function() {
        });
    });
}